// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-2[data-v-8f9934c4]{gap:8px}.bg-white[data-v-8f9934c4]{background-color:#fff!important}", ""]);
// Exports
module.exports = exports;
